export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12822.4a45fac6.jpg";